/**
 * Sürüklenen kolonun hücreleri başlıkla birlikte kayar: stil yalnız o kolonun hücrelerine
 * doğrudan yazılır. (`<table>` üstünde CSS değişkeni her karede tüm hücrelerin stilini yeniden
 * hesaplatıp kasıyordu; her hücrede `useSortable` ise aynı kimliği yüzlerce kez kaydeder.)
 */
export function moveColumnCells(
  table: HTMLTableElement,
  index: number,
  { x, transition, dragging }: { x?: number; transition?: string; dragging: boolean },
) {
  // Gövde hücreleri, başlık altındaki filtre satırı (ikinci `thead` satırı) ve alttaki toplam
  // satırı (`tfoot`) başlıkla birlikte kayar.
  const nth = index + 1
  const cells = table.querySelectorAll<HTMLElement>(
    `tbody > tr > td:nth-child(${nth}):not([colspan]), thead > tr:nth-child(2) > td:nth-child(${nth}), tfoot > tr > td:nth-child(${nth})`,
  )
  for (const cell of cells) {
    cell.style.transform = x ? `translateX(${x}px)` : ''
    cell.style.transition = transition ?? ''
    cell.style.position = x || dragging ? 'relative' : ''
    cell.style.zIndex = dragging ? '1' : ''
    cell.style.background = dragging ? 'var(--surface-muted)' : ''
  }
}
